import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  adminSignOut,
  applicantSignOut,
  RefreshAdminTokenAsync,
  selectAuth
} from '../../features/authentication/authSlice';
import AdminLogin from '../../features/authentication/AdminLogin';
import { Link, Outlet, useLocation } from 'react-router-dom';
import {
  AppBar,
  Box,
  CircularProgress,
  Container,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography
} from '@mui/material';
import { DrawerItem } from './types';
import cacheKeys from '../cacheKeys';
import { selectApp } from '../../app/appSlice';

const AdminWrapper = () => {
  const appState = useAppSelector(selectApp);
  const authState = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(applicantSignOut());
    const cachedTokens = sessionStorage.getItem(cacheKeys.adminRefreshTokenKey);
    if (cachedTokens) {
      dispatch(RefreshAdminTokenAsync(cachedTokens));
    }
  }, []);

  if ((!authState.admin.isLoggedIn && !authState.loading) || authState.attemptingLogin) {
    return <AdminLogin />;
  }

  const handleSignOut = () => {
    dispatch(adminSignOut());
  };

  const drawerItems: DrawerItem[] = [
    { name: 'Applicants', path: 'applicants' },
    { name: 'Questions', path: 'categories' },
    { name: 'Settings', path: 'settings' }
  ];

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Box flex={1}>
            <Typography>Admin page</Typography>
          </Box>
          <Box flex={1}>
            <Typography align="center">{appState.pageName}</Typography>
          </Box>
          <Box flex={1} />
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: 200,
          flexShrink: 0,
          ['& .MuiDrawer-paper']: { width: 200, boxSizing: 'border-box' }
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            {drawerItems.map(({ name, path }) => (
              <Link key={name} to={path} style={{ textDecoration: 'inherit', color: 'inherit' }}>
                <ListItem
                  disablePadding
                  sx={{ bgcolor: path === pathname.split('/')[2] ? 'primary.main' : null, borderRadius: 1 }}
                >
                  <ListItemButton>
                    <ListItemText primary={name} />
                  </ListItemButton>
                </ListItem>
              </Link>
            ))}
            <ListItem disablePadding>
              <ListItemButton onClick={handleSignOut}>
                <ListItemText primary={'Sign Out'} />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
      <Container maxWidth="xl">
        <Toolbar />
        {authState.loading ? <CircularProgress /> : <Outlet />}
      </Container>
    </Box>
  );
};

export default AdminWrapper;
